import PassportRequirementReviewerView from "./PassportRequirementReviewerView";

export default PassportRequirementReviewerView;